import { ActionReducer, Action } from "@ngrx/store";
import { TransactionsStore } from "@store/transactions";

export const transactionsReducer: ActionReducer<TransactionsStore> = (state: TransactionsStore = new TransactionsStore(), action: Action) => {

  const s: TransactionsStore = TransactionsStore.clone(state)

  switch(action.type) {

    case POPULATE_TRANSCATIONS:
      s.transactions = action.payload
      return s

    case POPULATE_ACTIVE_DEBTOR:
      s.activeDebtor = action.payload
      return s

    case POPULATE_POTENTIAL_TRANSACTIONS:
      s.potentialTransactions = action.payload
      return s

    case POPULATE_ACTIVE_TRANSACTION:
      s.activeTransaction = action.payload
      return s

    case POPULATE_DIRECT_DEBIT_SUMMARIES:
      s.directDebitSummaries = action.payload
      return s

    case POPULATE_ACTIVE_DIRECT_DEBIT_SUMMARY:
      s.activeDirectDebitSummary = action.payload
      return s

    case TOGGLE_TRANSACTIONS_CHECKED:
      s.transactions.forEach((t) => t.isChecked = action.payload)
      return s

    default:
      return state

  }
}

export const FETCH_TRANSACTIONS = "FETCH_TRANSACTIONS"
export const POPULATE_TRANSCATIONS = "POPULATE_TRANSCATIONS"
export const FETCH_TRANSACTIONS_FAILURE = "FETCH_TRANSACTIONS_FAILURE"
export const FETCH_POTENTIAL_TRANSACTIONS = "FETCH_POTENTIAL_TRANSACTIONS"
export const POPULATE_POTENTIAL_TRANSACTIONS = "POPULATE_POTENTIAL_TRANSACTIONS"
export const FETCH_POTENTIAL_TRANSACTIONS_FAILURE = "FETCH_POTENTIAL_TRANSACTIONS_FAILURE"
export const POPULATE_ACTIVE_DEBTOR = "POPULATE_ACTIVE_DEBTOR"
export const POPULATE_ACTIVE_TRANSACTION = "POPULATE_ACTIVE_TRANSACTION"
export const FETCH_DEBTOR = "FETCH_DEBTOR"
export const FETCH_DEBTOR_FAILURE = "FETCH_DEBTOR_FAILURE"
export const CREATE_TRANSACTION = "CREATE_TRANSACTION"
export const CREATED_TRANSACTION = "CREATED_TRANSACTION"
export const CREATE_TRANSACTION_FAILURE = "CREATE_TRANSACTION_FAILURE"
export const CREATE_TRANSACTION_TRANSFER = "CREATE_TRANSACTION_TRANSFER"
export const CREATED_TRANSACTION_TRANSFER = "CREATED_TRANSACTION_TRANSFER"
export const CREATE_TRANSACTION_TRANSFER_FAILURE = "CREATE_TRANSACTION_TRANSFER_FAILURE"
export const RECHARGE_TRANSACTION = "RECHARGE_TRANSACTION"
export const RECHARGED_TRANSACTION = "RECHARGED_TRANSACTION"
export const RECHARGE_TRANSACTION_FAILURE = "RECHARGE_TRANSACTION_FAILURE"
export const RECORD_OTHER_PAYMENT = "RECORD_OTHER_PAYMENT"
export const RECORDED_OTHER_PAYMENT = "RECORDED_OTHER_PAYMENT"
export const RECORD_OTHER_PAYMENT_FAILURE = "RECORD_OTHER_PAYMENT_FAILURE"
export const FETCH_DIRECT_DEBIT_SUMMARIES = "FETCH_DIRECT_DEBIT_SUMMARIES"
export const POPULATE_DIRECT_DEBIT_SUMMARIES = "POPULATE_DIRECT_DEBIT_SUMMARIES"
export const FETCH_DIRECT_DEBIT_SUMMARIES_FAILURE = "FETCH_DIRECT_DEBIT_SUMMARIES_FAILURE"
export const FETCH_DIRECT_DEBIT_SUMMARY = "FETCH_DIRECT_DEBIT_SUMMARY"
export const POPULATE_ACTIVE_DIRECT_DEBIT_SUMMARY = "POPULATE_ACTIVE_DIRECT_DEBIT_SUMMARY"
export const FETCH_DIRECT_DEBIT_SUMMARY_FAILURE = "FETCH_DIRECT_DEBIT_SUMMARY_FAILURE"
export const FETCH_DDS_TRANSACTIONS = "FETCH_DDS_TRANSACTIONS"
export const FETCH_DDS_TRANSACTIONS_FAILURE = "FETCH_DDS_TRANSACTIONS_FAILURE"
export const TOGGLE_TRANSACTIONS_CHECKED = "TOGGLE_TRANSACTIONS_CHECKED"
export const RECHARGE_TRANSACTIONS = "RECHARGE_TRANSACTIONS"



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/reducers/transactions.ts